<template>
    <v-dialog
        v-model="dialog"
        max-width="400"
        persistent
    >
        <v-card>
            <v-card-title class="headline d-flex align-center">
                <v-icon left color="orange">mdi-clock-outline</v-icon>
                Em Breve
            </v-card-title>

            <v-card-text>
                <div class="body-1 mb-3">
                    {{ message || 'Esta funcionalidade está sendo desenvolvida e estará disponível em breve.' }}
                </div>
                
                <v-alert
                    v-if="featureName"
                    type="info"
                    dense
                    text
                    class="mb-0"
                >
                    <strong>Funcionalidade:</strong> {{ featureName }}
                </v-alert>
            </v-card-text>

            <v-card-actions>
                <v-spacer />
                <v-btn
                    color="primary"
                    text
                    @click="close"
                >
                    Entendi
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: "SysCoreFeatureComingSoonDialog",

    data: () => ({
        dialog: false
    }),

    props: {
        show: {
            type: Boolean,
            default: false
        },
        featureName: {
            type: String,
            default: ''
        },
        message: {
            type: String,
            default: ''
        }
    },

    watch: {
        show(newVal) {
            this.dialog = newVal
        },
        dialog(newVal) {
            this.$emit('update:show', newVal)
        }
    },

    methods: {
        close() {
            this.dialog = false
            this.$emit('close')
        }
    }
}
</script>
